//@ts-nocheck

const navigation = () => {
  const button = document.querySelector(".js-hamburger");
  const header = document.querySelector(".js-header");

  button?.addEventListener("click", () => {
    if (header?.classList.contains("open")) {
      header?.classList.remove("open");
      button.innerText = "Menu";
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    } else {
      header?.classList.add("open");
      button.innerText = "Close";
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
    }
  });

  window.addEventListener("scroll", () => {
    document.documentElement.style.setProperty(
      "--scroll-y",
      `${window.scrollY}px`
    );
  });
};

export default navigation;
